import React from 'react';
import { Modal, Typography, Space, Tag } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { getShortcutsByCategory, formatShortcutDisplay } from 'keyboard';

const { Title, Text } = Typography;

/**
 * Keyboard Shortcuts Help Modal
 * Shows all available keyboard shortcuts to users
 */
const KeyboardShortcutsHelp = ({ visible, onClose }) => {
  const shortcutsByCategory = getShortcutsByCategory();

  return (
    <Modal
      title={
        <Space>
          <QuestionCircleOutlined />
          <span>Keyboard Shortcuts</span>
        </Space>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      width={500}
    >
      <Space direction="vertical" style={{ width: '100%' }} size="large">
        {Object.entries(shortcutsByCategory).map(([category, categoryShortcuts]) => (
          <div key={category}>
            <Title level={5}>{category}</Title>
            <Space direction="vertical" style={{ width: '100%' }}>
              {categoryShortcuts.map((shortcut, index) => (
                <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Text>{shortcut.description}</Text>
                  <Tag color="blue" style={{ fontFamily: 'monospace' }}>
                    {formatShortcutDisplay(shortcut)}
                  </Tag>
                </div>
              ))}
            </Space>
          </div>
        ))}
        
        <div style={{ 
          padding: '12px', 
          backgroundColor: '#f5f5f5', 
          borderRadius: '6px',
          fontSize: '12px',
          color: '#666'
        }}>
          <Text>
            💡 <strong>Tip:</strong> Keyboard shortcuts are disabled when typing in input fields to avoid conflicts.
          </Text>
        </div>
      </Space>
    </Modal>
  );
};

KeyboardShortcutsHelp.displayName = 'KeyboardShortcutsHelp';

export default KeyboardShortcutsHelp; 